import type { ReactNode, Ref } from 'react';
import type { TextInputSize } from '../TextInput/TextInput.types';

export type SelectOptionObject<TValue extends string = string> = {
  label: string;
  value: TValue;
  disabled?: boolean;
  tooltip?: string;
};
export type SelectOption<TValue extends string = string> =
  | TValue
  | SelectOptionObject<TValue>;

export function isSelectOptionObject<TValue extends string>(
  option: SelectOption<TValue>,
): option is SelectOptionObject<TValue> {
  return typeof option === 'object';
}

export type SelectBaseProps<TValue extends string> = {
  autoFocus?: boolean;
  className?: string;
  dataTestId?: string;
  disabled?: boolean;
  hasError?: boolean;
  inputRef?: Ref<HTMLInputElement>;
  loading?: boolean;
  name?: string;
  options: readonly SelectOption<TValue>[];
  size?: TextInputSize;
  startAdornment?: ReactNode;
  inputId?: string;
};

export type SelectClearableBaseProps<TValue extends string> =
  SelectBaseProps<TValue> & {
    clearable?: boolean;
    placeholder?: string;
  };

export type SelectProps<TValue extends string> =
  SelectClearableBaseProps<TValue> & {
    onChange: (value: TValue | null) => void;
    value: TValue | null;
  };

export type SelectMandatoryProps<TValue extends string> =
  SelectBaseProps<TValue> & {
    onChange: (value: TValue) => void;
    value: TValue;
  };
